import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ModalContainer } from 'react-router-modal';
import styled from 'styled-components';
import ModalRoute from '../common/components/ModalRoute';
import queryString from 'query-string';

import * as authActions from '../auth/auth.actions';
import * as campaignActions from '../campaign/campaign.actions';
import * as contentActions from '../content/content.actions';
import * as prizeActions from '../prize/prize.actions';
import * as productActions from '../product/product.actions';
import * as teamActions from '../team/team.actions';
import { getCurrentUser } from '../user/user.selectors';
import { UserRoles } from '../user/user.constants';

import AppHeader from '../common/components/app/AppHeader';
import AppFooter from '../common/components/app/AppFooter';

import Pages from '../pages';
import AdminPages from '../pages/admin';

import { ContentBlock } from '../pages/components';

import { CampaignFormContainer } from '../campaign/components';
import { ContentFormContainer } from '../content/components';
import { CreateChannelFormContainer } from '../channel/components';
import { CreateRegionFormContainer } from '../region/components';
import { ProductFormContainer, ProductScoresFormContainer } from '../product/components';
import { PrizeFormContainer } from '../prize/components';
import { CreateTeamFormContainer } from '../team/components';
import { TransactionsExportFormContainer } from '../transaction/components';
import { TransactionsSearchFormContainer } from '../transaction/components';
import { AddUserEntityContainer, CreateUserFormContainer } from '../user/components';

import SVGDefs from '../../icons/svgdefs';
import Background from '../../ui/Background';
import { PageContent, WrapperPageContent, WrapperPageContentNarrow } from '../../ui/PageContentWrappers';
import { Localize } from '../../locale/localization';
import LogoMtv from '../../ui/LogoMtv';
import ScrollTop from '../common/components/app/ScrollTop';

const StagingWarning = styled.div`
  position: fixed;
  height: 1.5rem;
  background: pink;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  line-height: 1.5rem;
  z-index: 10000;
  font-family: FyranSans-SemiBold;
`;

const SuperUserComponent = props => {
  return (
    <div>
      <Route exact path="/" component={Pages.HomePage} />
      <Route exact path="/admin" component={AdminPages.AdminPage} />

      <ModalRoute exact path="/admin/transactions/export" parentPath="/">
        <ContentBlock title="Tulosta raportti">
          <TransactionsExportFormContainer cancelPath="/admin" />
        </ContentBlock>
      </ModalRoute>
      <Route exact path="/admin/rules/:id" component={Pages.RulesPreviewPage} />
      <Route path="/admin/scores" component={AdminPages.ScoreAdminPage} />
      <ModalRoute path="/admin/scores/edit/:id" parentPath="/admin/scores">
        <ContentBlock title={Localize('scores.edit')}>
          <Route exact path="/admin/scores/edit/:id">
            <ProductScoresFormContainer cancelPath="/admin/scores" />
          </Route>
        </ContentBlock>
      </ModalRoute>

      <Route path="/admin/campaigns" component={AdminPages.CampaignAdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/campaigns/add" parentPath="/admin/campaigns">
          <ContentBlock title={Localize('campaign.add')}>
            <CampaignFormContainer cancelPath="/admin/campaigns" />
          </ContentBlock>
        </ModalRoute>
        <ModalRoute path="/admin/campaigns/edit/:id" parentPath="/admin/campaigns">
          <ContentBlock title={Localize('campaign.edit')}>
            <Route exact path="/admin/campaigns/edit/:id">
              <CampaignFormContainer cancelPath="/admin/campaigns" />
            </Route>
          </ContentBlock>
        </ModalRoute>
      </Switch>

      <Route path="/admin/prizes" component={AdminPages.PrizeAdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/prizes/add" parentPath="/admin/prizes">
          <ContentBlock title={Localize('prize.add')}>
            <PrizeFormContainer cancelPath="/admin/prizes" />
          </ContentBlock>
        </ModalRoute>
        <ModalRoute path="/admin/prizes/edit/:id" parentPath="/admin/prizes">
          <ContentBlock title={Localize('prize.edit')}>
            <Route exact path="/admin/prizes/edit/:id">
              <PrizeFormContainer cancelPath="/admin/prizes" />
            </Route>
          </ContentBlock>
        </ModalRoute>
      </Switch>

      <Route path="/admin/product-categories" component={AdminPages.ProductAdminPage} />
      <ModalRoute path="/admin/product-categories/edit/:id" parentPath="/admin/product-categories">
        <ContentBlock title={Localize('package.edit')}>
          <Route exact path="/admin/product-categories/edit/:id">
            <ProductFormContainer cancelPath="/admin/product-categories" />
          </Route>
        </ContentBlock>
      </ModalRoute>

      <Route path="/admin/rules" component={AdminPages.RulesAdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/rules/add" parentPath="/admin/rules">
          <ContentFormContainer type="rules" cancelPath="/admin/rules" />
        </ModalRoute>
        <ModalRoute path="/admin/rules/edit/:id" parentPath="/admin/rules">
          <Route exact path="/admin/rules/edit/:id">
            <ContentFormContainer type="rules" cancelPath="/admin/rules" />
          </Route>
        </ModalRoute>
      </Switch>

      <Route path="/admin/news" component={AdminPages.NewsAdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/news/add" parentPath="/admin/news">
          <ContentFormContainer type="news" cancelPath="/admin/news" />
        </ModalRoute>
        <ModalRoute path="/admin/news/edit/:id" parentPath="/admin/news">
          <Route exact path="/admin/news/edit/:id">
            <ContentFormContainer type="news" cancelPath="/admin/news" />
          </Route>
        </ModalRoute>
      </Switch>

      <Route path="/admin/inner-circle" component={AdminPages.InnerCircleAdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/inner-circle/add" parentPath="/admin/inner-circle">
          <ContentFormContainer type="inner-circle" cancelPath="/admin/inner-circle" />
        </ModalRoute>
        <ModalRoute path="/admin/inner-circle/edit/:id" parentPath="/admin/inner-circle">
          <Route exact path="/admin/inner-circle/edit/:id">
            <ContentFormContainer type="inner-circle" cancelPath="/admin/inner-circle" />
          </Route>
        </ModalRoute>
      </Switch>

      <Route path="/admin/users" component={AdminPages.UserAdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/users/add" parentPath="/admin/users">
          <ContentBlock title={Localize('admin.add.user')} center>
            <AddUserEntityContainer cancelPath="/admin/users" />
          </ContentBlock>
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/channel" parentPath="/admin/users">
          <CreateChannelFormContainer cancelPath="/admin/users" />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/region" parentPath="/admin/users">
          <CreateRegionFormContainer cancelPath="/admin/users" />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/team" parentPath="/admin/users">
          <CreateTeamFormContainer cancelPath="/admin/users" />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/user" parentPath="/admin/users">
          <CreateUserFormContainer cancelPath="/admin/users" userRole={UserRoles.SELLER} />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/assistant" parentPath="/admin/users">
          <CreateUserFormContainer cancelPath="/admin/users" userRole={UserRoles.ASSISTANT} />
        </ModalRoute>
        <ModalRoute path="/admin/users/transactions/:userId" parentPath="/admin/users">
          <Route exact path="/admin/users/transactions/:userId">
            <TransactionsSearchFormContainer cancelPath="/admin/users" />
          </Route>
        </ModalRoute>
      </Switch>
    </div>
  );
};

const SalesManagerComponent = props => {
  return (
    <div>
      <Route exact path="/" component={Pages.HomePage} />
      <Route exact path="/admin" component={AdminPages.AdminPage} />
      <Switch>
        <ModalRoute exact path="/admin/users/add" parentPath="/admin">
          <ContentBlock title={Localize('admin.add.user')} center>
            <AddUserEntityContainer cancelPath="/admin" />
          </ContentBlock>
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/region" parentPath="/admin">
          <CreateRegionFormContainer cancelPath="/admin" />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/team" parentPath="/admin">
          <CreateTeamFormContainer cancelPath="/admin" />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/user" parentPath="/admin">
          <CreateUserFormContainer cancelPath="/admin" userRole={UserRoles.SELLER} />
        </ModalRoute>
        <ModalRoute exact path="/admin/users/add/assistant" parentPath="/admin">
          <CreateUserFormContainer cancelPath="/admin" userRole={UserRoles.ASSISTANT} />
        </ModalRoute>
      </Switch>
    </div>
  );
};

const RegionManagerComponent = props => {
  return (
    <div>
      <Route exact path="/" component={Pages.HomePage} />
      <Route exact path="/admin" component={AdminPages.AdminPage} />
      <ModalRoute exact path="/admin/users/add" parentPath="/admin">
        <ContentBlock title={Localize('admin.add.user')} center>
          <AddUserEntityContainer cancelPath="/admin" />
        </ContentBlock>
      </ModalRoute>
      <ModalRoute exact path="/admin/users/add/team" parentPath="/admin">
        <CreateTeamFormContainer cancelPath="/admin" />
      </ModalRoute>
      <ModalRoute exact path="/admin/users/add/user" parentPath="/admin">
        <CreateUserFormContainer cancelPath="/admin" userRole={UserRoles.SELLER} />
      </ModalRoute>
      <ModalRoute exact path="/admin/users/add/assistant" parentPath="/admin">
        <CreateUserFormContainer cancelPath="/admin" userRole={UserRoles.ASSISTANT} />
      </ModalRoute>
    </div>
  );
};

const TeamLeaderComponent = props => {
  return (
    <div>
      <Route exact path="/" component={Pages.HomePage} />
      <Route path="/admin" component={AdminPages.AdminPage} />
      <ModalRoute exact path="/admin/users/add" parentPath="/admin">
        <ContentBlock title={Localize('admin.add.user')} center>
          <AddUserEntityContainer cancelPath="/admin" />
        </ContentBlock>
      </ModalRoute>
      <ModalRoute exact path="/admin/users/add/user" parentPath="/admin">
        <CreateUserFormContainer cancelPath="/admin" userRole={UserRoles.SELLER} />
      </ModalRoute>
      <ModalRoute exact path="/admin/users/add/assistant" parentPath="/admin">
        <CreateUserFormContainer cancelPath="/admin" userRole={UserRoles.ASSISTANT} />
      </ModalRoute>
    </div>
  );
};

const BasicUserComponent = props => {
  return <Route path="/" component={Pages.HomePage} />;
};

class App extends Component {
  state = {
    initial: true,
  };

  constructor(props) {
    super(props);

    const { loginUserToken } = props;
    const token = localStorage.getItem('cmore-sisapiiri-token') || null;
    loginUserToken(token);
  }

  onLogoutClick = () => {
    const { logoutUser } = this.props;
    logoutUser();
  };

  //TODO Logic for loading stuff TBD
  componentWillReceiveProps = nextProps => {
    const { isAuthenticated /*, productsLoaded*/ } = nextProps;
    //const wereProductsLoaded = this.props.productsLoaded;
    const { initial } = this.state;
    const parsed = queryString.parse(window.location.search);

    if (isAuthenticated) {
      if (initial) {
        this.setState({ initial: false });
        const {
          getContents,
          getFilteredContents,
          getPrizes,
          getProducts,
          getCurrentCampaign,
          getTeams,
          getTags,
        } = this.props;

        if (parsed.filter && parsed.filter !== '') {
          getFilteredContents([parsed.filter]);
        } else {
          getContents();
        }
        getTags();
        getPrizes();
        getProducts(true);
        if (this.props.role === UserRoles.SUPERUSER) {
          getTeams();
        }
        getCurrentCampaign();
      }
    }
  };

  renderRoleContent(role) {
    switch (role) {
      case UserRoles.SUPERUSER:
        return <Route path="/" component={SuperUserComponent} />;
      case UserRoles.SALESMANAGER:
        return <Route path="/" component={SalesManagerComponent} />;
      case UserRoles.REGIONMANAGER:
        return <Route path="/" component={RegionManagerComponent} />;
      case UserRoles.TEAMLEADER:
        return <Route path="/" component={TeamLeaderComponent} />;
      case UserRoles.SELLER:
      case UserRoles.ASSISTANT:
        return <Route path="/" component={BasicUserComponent} />;
      default:
        return null;
    }
  }

  render() {
    //TODO Initial status (loading, initializing, etc.)
    const { isAuthenticated, isLoading, role, currentUser } = this.props;
    if (isLoading) {
      return null;
    }

    return (
      <Background>
        <SVGDefs />
        {process.env.REACT_APP_NODE_ENV === 'staging' && <StagingWarning>Olet Staging-ympäristössä</StagingWarning>}
        <Switch>
          <ScrollTop>
            <Route
              path="/"
              render={props => {
                return (
                  <WrapperPageContent>
                    {isAuthenticated ? (
                      <PageContent>
                        <AppHeader location={props.location} />
                        <Switch>
                          <Route path="/profile" component={Pages.ProfilePage} />
                          {currentUser.hasAccessToPrizeProgram && (
                            <Route path="/prizes/(rules|preview)?/:id?" component={Pages.PrizesPage} />
                          )}
                          <Route path="/product-categories" component={Pages.ProductsPage} />
                          <Route path="/news/archive" component={Pages.NewsArchivePage} />
                          <Route path="/news/:name/:id?" component={Pages.NewsPage} />
                          <Route path="/inner-circle/archive" component={Pages.InnerCircleArchivePage} />
                          <Route path="/inner-circle/:id?" component={Pages.InnerCirclePage} />
                          <Route exact path="/privacy" component={Pages.PrivacyPage} />
                          <Route exact path="/rules/:id" component={Pages.RulesPreviewPage} />
                          {this.renderRoleContent(role)}
                        </Switch>
                      </PageContent>
                    ) : (
                      <WrapperPageContentNarrow>
                        <LogoMtv />
                        <Switch>
                          <Route
                            exact
                            path="/resetPassword/:emailToken"
                            render={() => {
                              return !isAuthenticated ? <Pages.ResetPasswordPage /> : <Redirect to="/" />;
                            }}
                          />
                          <Route
                            exact
                            path="/register/:emailToken"
                            render={() => {
                              return !isAuthenticated ? <Pages.RegistrationPage /> : <Redirect to="/" />;
                            }}
                          />
                          <Route exact path="/(resetPassword|unauthorized)?" component={Pages.LoginPage} />
                          <Redirect to="/" />
                        </Switch>
                      </WrapperPageContentNarrow>
                    )}
                  </WrapperPageContent>
                );
              }}
            />
          </ScrollTop>
        </Switch>
        <AppFooter />
        <ModalContainer />
      </Background>
    );
  }
}

const mapStateToProps = state => {
  const { auth } = state;

  const { isAuthenticated, isLoading, role } = auth;
  // const products = getAllProducts(state);
  //const productsLoaded = products.length > 0;
  const currentUser = getCurrentUser(state);

  return {
    isAuthenticated,
    isLoading,
    role,
    currentUser,
    //productsLoaded,
  };
};

const ConnectedApp = connect(
  mapStateToProps,
  Object.assign({}, authActions, campaignActions, contentActions, prizeActions, productActions, teamActions)
)(App);

export default ConnectedApp;



// WEBPACK FOOTER //
// ./src/modules/core/App.js